import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-alert-fill text-primary-500 text-xl"></i>
              </span>
              <span className="text-foreground-950 font-bold text-lg font-heading whitespace-nowrap">
                17吃瓜
              </span>
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-foreground-800 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap cursor-pointer">
                首页
              </Link>
              <div className="relative group">
                <Link to="/category/wanghong-heiliao" className="text-foreground-800 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                  分类浏览
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </Link>
                <div className="absolute top-full left-0 mt-2 w-40 bg-white border border-background-200 rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 overflow-hidden shadow-sm">
                  <Link to="/category/wanghong-heiliao" className="block px-4 py-2.5 text-sm text-foreground-800 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">网红黑料</Link>
                  <Link to="/category/mingxing-tafang" className="block px-4 py-2.5 text-sm text-foreground-800 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">明星塌房</Link>
                  <Link to="/category/zhibo-chigua" className="block px-4 py-2.5 text-sm text-foreground-800 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">直播吃瓜</Link>
                  <Link to="/category/yule-bagua" className="block px-4 py-2.5 text-sm text-foreground-800 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">娱乐八卦</Link>
                </div>
              </div>
              <Link to="/category/shejiao-remen" className="text-foreground-800 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap cursor-pointer">
                社交热门
              </Link>
              <Link to="/about" className="text-foreground-800 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button className="hidden md:flex w-8 h-8 items-center justify-center cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-800 text-lg hover:text-foreground-950 transition-colors"></i>
            </button>
            <Link
              to="/about"
              className="hidden md:flex items-center gap-1.5 bg-primary-500 text-foreground-50 text-sm font-semibold px-5 py-2 rounded-full cursor-pointer hover:bg-primary-400 transition-all whitespace-nowrap"
            >
              <span>我要爆料</span>
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
            <button
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-foreground-950 text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>首页</Link>
            <Link to="/category/wanghong-heiliao" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>网红黑料</Link>
            <Link to="/category/mingxing-tafang" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>明星塌房</Link>
            <Link to="/category/zhibo-chigua" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>直播吃瓜</Link>
            <Link to="/category/yule-bagua" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>娱乐八卦</Link>
            <Link to="/about" className="text-foreground-800 text-sm py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>关于我们</Link>
            <Link to="/about" className="flex items-center justify-center gap-1.5 bg-primary-500 text-foreground-50 text-sm font-semibold px-5 py-2.5 rounded-full cursor-pointer hover:bg-primary-400 transition-all whitespace-nowrap mt-2" onClick={() => setMobileOpen(false)}>
              <span>我要爆料</span>
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}